import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-accent-400 text-xl"></i>
                </span>
                <span className="font-heading text-lg font-bold text-foreground-50">
                  传教士体位指南
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                科学视角，专业指导。<br />
                专注传教士体位知识科普<br />
                与亲密关系质量提升。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">内容分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#contact" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    联系我们
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-50 mb-4">免责声明</h4>
              <p className="text-xs text-foreground-500 leading-relaxed">
                本网站内容仅供成年人阅读，旨在提供科学的健康知识科普。所有内容不构成医学建议，如有健康问题请咨询专业医生。
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 传教士体位指南. 保留所有权利.
            </p>
            <p className="text-xs text-foreground-500">
              本站内容仅供成年读者参考
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}